import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Zoom from "react-reveal/Zoom";
import Slide from "react-reveal/Slide";
import * as Yup from "yup";
import Jello from "react-reveal/Jello";
import axios from "axios";

function Registrati() {
  const [showPatente, setShowPatente] = useState(false);
  const [showPagamento, setShowPagamento] = useState(false);

  let history = useHistory();

  const initialValues = {
    nome: "",
    provincia: "",
    dataNascita: "",
    CAP: "",
    telefono: "",
    cognome: "",
    comune: "",
    indirizzo: "",
    regione: "",
    email: "",
    confermaEmail: "",
    password: "",
    confermaPassword: "",
    nomeIntestatario: "",
    codiceCarta: "",
    cvc: "",
    codicePatente: "",
    nominativo: "",
  };

  const onSubmit = (data) => {

    var today = new Date();

    var annoVerifica = today.getFullYear() - 14;

    if (((today.getMonth() + 1) < 10) && (today.getDate() >= 10)){
      var dataOdierna = annoVerifica+ "-0" +(today.getMonth()+1)+ "-"+ today.getDate();
    } else if (((today.getMonth() + 1) >= 10) && (today.getDate() < 10)) {
      var dataOdierna = annoVerifica+ "-" +(today.getMonth()+1)+ "-0"+ today.getDate();
    } else if (((today.getMonth() + 1) < 10) && (today.getDate() < 10)){
      var dataOdierna = annoVerifica+ "-0" +(today.getMonth()+1)+ "-0"+ today.getDate();
    } else {
      var dataOdierna = annoVerifica+ "-" +(today.getMonth()+1)+ "-"+ today.getDate();
    }


    
  
    console.log(dataOdierna);
    console.log(data.dataNascita)

    console.log(data.dataNascita < dataOdierna)

    if (data.dataNascita < dataOdierna) {
      if (
        showPagamento &&
        (!data.codiceCarta ||
          !data.nomeIntestatario ||
          !data.scadenzaCarta ||
          !data.cvc)
      ) {
        alert("Errore: Devi inserire TUTTI i dati del metodo di pagamento!");
      } else if (
        showPatente &&
        (!data.codicePatente ||
          !data.nominativo ||
          !data.dataRilascio ||
          !data.scadenzaPatente)
      ) {
        alert("Errore: Devi inserire TUTTI i dati della patente!");
      } else {
        if (data.email !== data.confermaEmail) {
          alert("Errore: Controlla di avere reinserito correttamente l'email!");
        } else if (data.password !== data.confermaPassword) {
          alert(
            "Errore: Controlla di avere reinserito corretamente la password!"
          );
        } else {
          axios
            .post(
              "https://website-8bit-motors.herokuapp.com/account/Registrati",
              data
            )
            .then((response) => {
              if (response.data.error) {
                alert(response.data.error);
              } else {
                history.push("/account/registrati/registrazioneCheck");
              }
            });
        }
      }
    } else {
      alert("Devi avere almeno 14 anni per registrarti!");
    }
  };

  const validationSchema = Yup.object().shape({
    nome: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(15, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    cognome: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(15, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    provincia: Yup.string()
      .min(2, "Valore non valido: Troppo corto!")
      .max(2, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    CAP: Yup.string().required("Per continuare devi compilare questo campo!"),
    dataNascita: Yup.date().required(
      "Per continuare devi compilare questo campo!"
    ),
    telefono: Yup.string().required(
      "Per continuare devi compilare questo campo!"
    ),
    regione: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(15, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    comune: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(15, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    indirizzo: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(25, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    email: Yup.string()
      .email("Inserisci una email valida")
      .required("Per continuare devi compilare questo campo!"),
    password: Yup.string()
      .min(5, "Valore non valido: Troppo corto!")
      .max(20, "Valore non valido: Troppo lungo!"),
    nomeIntestatario: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(20, "Valore non valido: Troppo lungo!"),
    codiceCarta: Yup.number("Devi inserire solamente numeri!").min(
      16,
      "Valore non valido: Troppo corto!"
    ),
    cvc: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(3, "Valore non valido: Troppo lungo!"),
    scadenzaCarta: Yup.date(),
    scadenzaPatente: Yup.date(),
    nominativo: Yup.string().min(5).max(20),
    dataRilascio: Yup.date(),
    codicePatente: Yup.string().min(6).max(10),
  });

  return (
    <Container fluid className="app">
      <Jello>
        {/* SEZIONE BANNER */}
        <Container
          fluid
          className="head-banner text-white text-center"
          id="banner_accesso"
        >
          <Row>
            <Col>
              <h1>
                <strong>8-Bit Motors</strong>
              </h1>
            </Col>
          </Row>
        </Container>
      </Jello>

      {/* FORM REGISTRAZIONE */}
      <Container className="form_registrazione">
        <h2 className="mt-3">Dati Anagrafici</h2>
        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          <Form>
            <Row className="justify-content-md-center mt-3">
              <Col>
                <Slide left>
                  <label className="mb-1 form_registrazione" for="nome">
                    Nome
                  </label>
                  <ErrorMessage name="nome" component="h6" />
                  <Field
                    className="form-control input_registrazione"
                    name="nome"
                    placeholder="Mario"
                  />
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    for="provincia"
                  >
                    Provincia
                  </label>
                  <ErrorMessage name="provincia" component="h6" />
                  <Field
                    type="text"
                    className="form-control input_registrazione"
                    name="provincia"
                    placeholder="PA"
                  />
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    for="dataDiNascita"
                  >
                    Data di Nascita
                  </label>
                  <ErrorMessage name="dataNascita" component="h6" />
                  <Field
                    type="date"
                    className="form-control input_registrazione"
                    name="dataNascita"
                    placeholder="01/01/2000"
                  />
                  <label className="mb-1 mt-3 form_registrazione" for="cap">
                    CAP
                  </label>
                  <ErrorMessage name="CAP" component="h6" />
                  <Field
                    type="number"
                    className="form-control input_registrazione"
                    name="CAP"
                    placeholder="90145"
                  />
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    for="telefono"
                  >
                    Telefono
                  </label>
                  <ErrorMessage name="telefono" component="h6" />
                  <Field
                    type="number"
                    className="form-control input_registrazione"
                    name="telefono"
                    placeholder="3342342421"
                  />
                </Slide>
              </Col>
              <Col>
                <Slide right>
                  <label className="mb-1 form_registrazione">Cognome</label>
                  <ErrorMessage name="cognome" component="h6" />
                  <Field
                    type="text"
                    className="form-control input_registrazione"
                    name="cognome"
                    placeholder="Rossi"
                  />
                  <label className="mb-1 mt-3 form_registrazione">
                    Regione
                  </label>
                  <ErrorMessage name="regione" component="h6" />
                  <Field
                    type="text"
                    className="form-control input_registrazione"
                    name="regione"
                    placeholder="Sicilia"
                  />
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    name="comune"
                    for="comune"
                  >
                    Comune
                  </label>
                  <ErrorMessage name="comune" component="h6" />
                  <Field
                    type="text"
                    className="form-control input_registrazione"
                    name="comune"
                    placeholder="Palermo"
                  />
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    name="indirizzo"
                    for="indirizzo"
                  >
                    Indirizzo
                  </label>
                  <ErrorMessage name="indirizzo" component="h6" />
                  <Field
                    type="text"
                    className="form-control input_registrazione"
                    name="indirizzo"
                    placeholder="Via della Libertà"
                  />
                </Slide>
              </Col>
            </Row>

            {/* SEZIONE PAGAMENTO */}

            <Zoom left opposite cascade collapse when={showPagamento}>
              <h2 className="mt-3">Dati Pagamento</h2>
              <Row>
                <Col>
                  <label
                    class="mb-1 mt-3 form_registrazione"
                    for="nomeIntestatario"
                  >
                    Nome Intestatario
                  </label>
                  <ErrorMessage name="nomeIntestatario" component="h6" />
                  <Field
                    id="nomeIntestatario"
                    type="text"
                    class="form-control input_registrazione"
                    placeholder="Inserisci Nome Intestatario"
                    name="nomeIntestatario"
                  />
                  <label
                    class="mb-1 mt-3 form_registrazione"
                    for="scadenzaCarta"
                  >
                    Scadenza Carta
                  </label>
                  <ErrorMessage name="scadenzaCarta" component="h6" />
                  <Field
                    type="date"
                    class="form-control input_registrazione"
                    placeholder="Inserisci Scadenza Carta"
                    name="scadenzaCarta"
                  />
                </Col>
                <Col>
                  <label class="mb-1 mt-3 form_registrazione" for="codiceCarta">
                    Codice Carta
                  </label>
                  <ErrorMessage name="codiceCarta" component="h6" />
                  <Field
                    type="text"
                    class="form-control input_registrazione"
                    placeholder="Inserisci Codice Carta"
                    name="codiceCarta"
                  />
                  <label class="mb-1 mt-3 form_registrazione" for="cvc">
                    CVC
                  </label>
                  <ErrorMessage name="cvc" component="h6" />
                  <Field
                    type="number"
                    class="form-control input_registrazione"
                    placeholder="Inserisci CVC"
                    name="cvc"
                  ></Field>
                </Col>
              </Row>
            </Zoom>

            <button
              className="btn btn-warning my-5"
              type="button"
              onClick={() => {
                setShowPagamento(!showPagamento);
              }}
            >
              {showPagamento ? "Non Mostrare" : "Mostra"} Campi Pagamento
            </button>

            {/* SEZIONE PATENTE */}

            <Zoom left cascade collapse when={showPatente}>
              <h2 className="mt-3">Dati Patente</h2>
              <Row>
                <Col>
                  <label
                    class="mb-1 mt-3 form_registrazione"
                    for="codicePatente"
                  >
                    Codice Patente
                  </label>
                  <ErrorMessage name="codicePatente" component="h6" />
                  <Field
                    type="text"
                    class="form-control input_registrazione"
                    placeholder="Inserisci Codice Patente"
                    name="codicePatente"
                  />
                  <label
                    class="mb-1 mt-3 form_registrazione"
                    for="scadenzaPatente"
                  >
                    Scadenza Patente
                  </label>
                  <ErrorMessage name="scadenzaPatente" component="h6" />
                  <Field
                    type="date"
                    class="form-control input_registrazione"
                    placeholder="Inserisci Scadenza"
                    name="scadenzaPatente"
                  ></Field>
                </Col>
                <Col>
                  <label
                    class="mb-1 mt-3 form_registrazione"
                    for="dataRilascio"
                  >
                    Data Rilascio
                  </label>
                  <ErrorMessage name="dataRilascio" component="h6" />
                  <Field
                    type="date"
                    class="form-control input_registrazione"
                    placeholder="Inserisci Data Rilascio"
                    name="dataRilascio"
                  />
                  <label class="mb-1 mt-3 form_registrazione" for="nominativo">
                    Nominativo
                  </label>
                  <ErrorMessage name="nominativo" component="h6" />
                  <Field
                    type="text"
                    class="form-control input_registrazione"
                    placeholder="Inserisci Nominativo"
                    name="nominativo"
                  />
                </Col>
              </Row>
            </Zoom>

            <button
              className="btn btn-warning my-5"
              type="button"
              onClick={() => setShowPatente(!showPatente)}
            >
              {showPatente ? "Non Mostrare" : "Mostra"} Campi Patente
            </button>

            {/* SEZIONE ACCOUNT */}
            <Row className="justify-content-md-center mt-3">
              <h2>Dati Account</h2>
              <Col>
                <Slide left>
                  <label className="mb-1 mt-3 form_registrazione">E-mail</label>
                  <ErrorMessage name="email" component="h6" />
                  <Field
                    type="email"
                    className="form-control input_registrazione"
                    name="email"
                    placeholder="Inserisci E-mail"
                  />
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    for="password"
                  >
                    Password
                  </label>
                  <ErrorMessage name="password" component="h6" />
                  <Field
                    type="password"
                    className="form-control input_registrazione"
                    name="password"
                    placeholder="Inserisci Password"
                  />
                </Slide>
              </Col>
              <Col>
                <Slide right>
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    for="confermaEmail"
                  >
                    Conferma E-mail
                  </label>
                  <Field
                    type="email"
                    className="form-control input_registrazione"
                    name="confermaEmail"
                    placeholder="Inserisci E-mail"
                  />
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    for="confermaPassword"
                  >
                    Conferma Password
                  </label>
                  <Field
                    type="password"
                    className="form-control input_registrazione"
                    name="confermaPassword"
                    placeholder="Inserisci Password"
                  />
                </Slide>
              </Col>
            </Row>

            {/* CONFERMA */}
            <Button variant="success" className="mt-3" type="submit">
              Conferma
            </Button>
          </Form>
        </Formik>
      </Container>
    </Container>
  );
}

export default Registrati;
